module.exports = __webpack_public_path__ + "img/car_00047.f176a7c4.jpg";